import { render, staticRenderFns } from "./ManageSiteDomains.vue?vue&type=template&id=75935fb0&"
import script from "./ManageSiteDomains.vue?vue&type=script&lang=js&"
export * from "./ManageSiteDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports